import React from 'react';

export default function SectionHeader({ chapter, label, heading, anchor }) {
  return (
    <div id={anchor} className="mb-12">
      <div className="chapter-rule mb-8">
        <div className="flex items-center gap-4">
          <span className="font-sc text-[10px] gold-text tracking-[0.42em]">{chapter}</span>
          {label && <span className="font-sc text-[10px] text-[color:var(--bx-muted)] tracking-[0.4em]">{label}</span>}
        </div>
        <div className="line" />
      </div>
      <h2 className="heading-xl text-3xl md:text-5xl text-gold-orange">{heading}</h2>
    </div>
  );
}
